import { RouterError } from '../Components/RouterError'
import { getInitialLanguage } from './initialLanguage'
import { LanguageWrapper } from './LanguageWrapper'

/**
 * Router errorElement. A route error can blow away the data-context language
 * layer, so the error UI gets its own LanguageWrapper seeded from storage/URL,
 * keeping the error page translated.
 */
export const AppErrorBoundary = () => (
  <LanguageWrapper language={getInitialLanguage()}>
    <RouterError />
  </LanguageWrapper>
)
